import React, { useState, useRef, useEffect } from 'react'
import Icon from './Icon'
import PreviewImg from './previewImg'
import { SUB_TAB_OPTIONS } from './constants'

export default function SubTabScrollList({ imgs, loading, subTab, onSubTabChange, refImgs, onSelect, onOpenMeinianGallery }) {
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const scrollRef = useRef(null)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return
    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1)
  }, [imgs])

  const handleScroll = e => {
    const el = e.target
    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1)
  }

  const scrollTo = dir => {
    const el = scrollRef.current
    if (!el) return
    el.scrollTo({ left: el.scrollLeft + (dir === 'left' ? -200 : 200), behavior: 'smooth' })
  }

  return (
    <>
      <div className="ref-imgs-subtabs-row">
        <div className="ref-imgs-subtabs">
          {SUB_TAB_OPTIONS.map(opt => (
            <button
              type="button"
              key={opt.value}
              className={`ref-imgs-subtab ${subTab === opt.value ? 'active' : ''}`}
              onClick={() => onSubTabChange(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
        <button type="button" className="meinian-gallery-entry" onClick={onOpenMeinianGallery}>
          <span className="meinian-gallery-entry-logo" />
          <span>更多美念图库</span>
          <span className="meinian-gallery-entry-arrow" />
        </button>
      </div>

      <div className="ref-imgs-scroll-container">
        {canScrollLeft && (
          <>
            <button type="button" className="scroll-btn scroll-btn-left" onClick={() => scrollTo('left')}>
              <Icon type="zykj-xiangzuo" />
            </button>
            <div className="scroll-fade scroll-fade-left" />
          </>
        )}
        <div className="ref-imgs-scroll" ref={scrollRef} onScroll={handleScroll}>
          {loading && <span className="ref-imgs-scroll-loading">加载中...</span>}
          {!loading && imgs.length === 0 && (
            <span className="ref-imgs-scroll-empty">暂无数据</span>
          )}
          {!loading && imgs.map(item => {
            const key = item.id ?? item.url
            const selected = refImgs.some(r => (r.id ?? r.url) === key)
            return (
              <PreviewImg key={key} src={item.url} side="top" overlayClassName="fdai-scroll-preview-tooltip">
                <div
                  className={`ref-imgs-scroll-item${selected ? ' selected' : ''}`}
                  onClick={() => onSelect(item.url, item.id)}
                >
                  <img src={item.url} alt="" />
                  {selected && <span className="scroll-item-selected-icon"><Icon type="zykj-gouxuan" /></span>}
                </div>
              </PreviewImg>
            )
          })}
        </div>
        {canScrollRight && (
          <>
            <div className="scroll-fade scroll-fade-right" />
            <button type="button" className="scroll-btn scroll-btn-right" onClick={() => scrollTo('right')}>
              <Icon type="zykj-xiangyou" />
            </button>
          </>
        )}
      </div>
    </>
  )
}
